import { useEffect, useRef, useCallback } from 'react';

export const INACTIVITY_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes
const LAST_ACTIVITY_KEY = 'last_activity';
const WRITE_THROTTLE_MS = 15 * 1000; // write to localStorage at most once every 15s
const EVENTS = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click'];

export function useInactivityLogout(onLogout, enabled = true) {
  const timerRef    = useRef(null);
  const lastWriteRef = useRef(0);

  const reset = useCallback(() => {
    if (!enabled) return;
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      onLogout('inactivity');
    }, INACTIVITY_TIMEOUT_MS);

    // Throttled write so mousemove storms don't hammer localStorage
    const now = Date.now();
    if (now - lastWriteRef.current > WRITE_THROTTLE_MS) {
      localStorage.setItem(LAST_ACTIVITY_KEY, now.toString());
      lastWriteRef.current = now;
    }
  }, [enabled, onLogout]);

  useEffect(() => {
    if (!enabled) return;
    reset();
    EVENTS.forEach(e => window.addEventListener(e, reset, { passive: true }));
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      EVENTS.forEach(e => window.removeEventListener(e, reset));
    };
  }, [enabled, reset]);
}
